import * as React from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

const SpinnerButton = ({
  id,
  label,
  isLoading,
  buttonColor = 'black',
  textColor = 'white',
  border = 'none',
  width,
  height,
  sx = {},
  ...others
}) => {
  const buttonWidth = width || 'max-content'

  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{ justifyContent: 'center', margin: '1rem 0rem' }}
    >
      <Button
        variant="contained"
        id={id}
        style={
          {
            // backgroundColor: buttonColor,
            // color: textColor,
            // border: border,
            // width: buttonWidth,
          }
        }
        // sx={{ ...sx }}
        {...others}
      >
        {isLoading ? <CircularProgress size={20} color="inherit" /> : label}
      </Button>
    </Stack>
  )
}

export default SpinnerButton
